import { SvgIcon, SvgIconProps, Tooltip } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import RestoreIcon from '@material-ui/icons/Restore';
import React from 'react';

const Inventory2Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 -960 960 960">
    <path d="M200-80q-33 0-56.5-23.5T120-160v-451q-18-11-29-28.5T80-680v-120q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v120q0 23-11 40.5T840-611v451q0 33-23.5 56.5T760-80H200Zm0-520v440h560v-440H200Zm-40-80h640v-120H160v120Zm200 280h240v-80H360v80Zm120 20Z" />
  </SvgIcon>
);

const useStyles = makeStyles((theme: Theme) => ({
  closedIcon: {
    color: theme.palette.actionSecondary.active,
  },
  reopenedIcon: {
    color: theme.palette.warning.dark,
  },
}));

interface FileStatusIndicatorProps {
  fileInfoStatus?: string;
  isReopened?: boolean;
}

const CLOSED_TOOLTIP = 'Closed File';
const REOPENED_TOOLTIP = 'Reopened File';

export const FileStatusIndicator: React.FC<FileStatusIndicatorProps> = ({ fileInfoStatus, isReopened }) => {
  const classes = useStyles();

  const isClosed = fileInfoStatus === 'Closed';

  // Reopened takes precedence over closed (AC3)
  if (isReopened) {
    return (
      <Tooltip title={REOPENED_TOOLTIP} enterDelay={300} placement="right" arrow>
        <RestoreIcon fontSize="small" className={classes.reopenedIcon} />
      </Tooltip>
    );
  }

  if (isClosed) {
    return (
      <Tooltip title={CLOSED_TOOLTIP} enterDelay={300} placement="right" arrow>
        <span>
          <Inventory2Icon fontSize="small" className={classes.closedIcon} />
        </span>
      </Tooltip>
    );
  }

  return null;
};

export default FileStatusIndicator;
